import { sharedItemsCollection } from '@izimi/api';
import { CommunicationDetailsEntity } from '../communications';
import { DocumentEntity } from '../documents';
export const isCommunicationDetails = (item) => item._collection === sharedItemsCollection.NOT_EXPIRING_COMMUNICATION_DETAILS || item._collection === sharedItemsCollection.EXPIRING_COMMUNICATION_DETAILS;
export const isDocument = (item) => item._collection === sharedItemsCollection.PUSHED_DOCUMENTS || item._collection === sharedItemsCollection.SHARED_DOCUMENTS;
export const mapSharedItemsToEntities = ({ items }) => items?.map((item) => {
    if (isCommunicationDetails(item)) {
        return new CommunicationDetailsEntity(item, item._collection?.toString());
    }
    if (isDocument(item)) {
        return new DocumentEntity(item, item._collection?.toString());
    }
    return null;
}).filter((item) => Boolean(item));
